import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createOnboardingSlice } from './slices/onboarding/createOnboardingSlice';
import { IOnboardingSlice } from '../types/onboarding.types';
import { IErrorSlice } from '../types/error.types';
import { createErrorSlice } from './slices/error/createErrorSlice';
import { createCustomerSlice } from './slices/customer/createCustomerSlice';
import { ICustomerSlice } from './slices/customer/customer.types';
import { IKybSlice } from './slices/kyb/kyb.types';
import { createKybSlice } from './slices/kyb/createKybSlice';
import { IAuthOnboardingSlice } from '@Store/slices/authOnboarding/authOnboarding.types.ts';
import { createAuthOnboardingSlice } from '@Store/slices/authOnboarding/createAuthOnboardingSlice.ts';

// Define the root state type
type RootType = IOnboardingSlice &
  IErrorSlice &
  ICustomerSlice &
  IAuthOnboardingSlice &
  IKybSlice & {
    isLoaded: boolean;
    setLoaded: (loaded: boolean) => void;
    isHydrated: boolean;
    setIsHydrated: (hydrated: boolean) => void;
  };

const useStore = create<RootType>()(
  devtools((...a) => ({
    ...createOnboardingSlice(...a),
    ...createErrorSlice(...a),
    ...createCustomerSlice(...a),
    ...createKybSlice(...a),
    ...createAuthOnboardingSlice(...a),
    isLoaded: false,
    setLoaded: (loaded: boolean) => {
      useStore.setState({ isLoaded: loaded });
    },
    isHydrated: false,
    setIsHydrated: (hydrated: boolean) => {
      useStore.setState({ isHydrated: hydrated });
    },
  }))
);

// HMR Support
if (import.meta.hot?.data) {
  if (import.meta.hot.data.store) {
    // Replace the current store with the stored one
    useStore.setState(import.meta.hot.data.store.getState());
  }

  import.meta.hot.accept();

  import.meta.hot.dispose((data) => {
    data.store = useStore;
  });
}

export const useBoundStore = useStore;
